import { registerPlugin } from '@capacitor/core';

import { AttributeName, TraceName } from 'utils/performance';

interface ITraceOptions {
  traceName: TraceName;
}

interface IGetAttributeOptions extends ITraceOptions {
  attributeName: AttributeName;
}

interface ISetAttributeOptions extends IGetAttributeOptions {
  attributeValue: string;
}

interface ICancelTraceResult {
  cancelled: boolean;
}

interface IFirebasePerformancePlugin {
  startTrace: (options: ITraceOptions) => void;
  stopTrace: (options: ITraceOptions) => void;
  cancelTrace: (options: ITraceOptions) => Promise<ICancelTraceResult>;
  getTraceAttribute: (options: IGetAttributeOptions) => { attributeValue: string };
  setTraceAttribute: (options: ISetAttributeOptions) => void;
}

export const FirebasePerformancePlugin = registerPlugin<IFirebasePerformancePlugin>(
  'FirebasePerformancePlugin'
);
